module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"uploadFile":"Import","File":"File","UploadImageSizeStr":"Uploaded file size cannot exceed"},"zh":{"uploadFile":"导入","File":"文件","UploadImageSizeStr":"上传文件大小不能超过"},"mm":{"uploadFile":"တင်သွင်းပါ","File":"ဖိုင်","UploadImageSizeStr":"တင်မည့်ပုံသည် ဆိုဒ် ထက်မပိုရ"}}')
  delete Component.options._Ctor
}
